import React, { useState } from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';

import Axios from 'axios';

import Cookies from 'universal-cookie';

import { SetListData } from 'interface/Data';

import { typeCookieEmail, typeCookiePassw, typeCookieType } from 'fixedData';

import { Access } from 'services/AccessLogin';
import { SetListPag } from 'interface/Page';

const root = ReactDOM.createRoot(document.getElementById('root'));

const cookies = new Cookies();

const data = new FormData();
data.append('type_page', 'show_data_initial');

if(cookies.get(typeCookieEmail)){
    Access('return', cookies.get(typeCookieEmail), cookies.get(typeCookiePassw), ()=>{ CallbackSuccess() }, ()=>{ CallbackError() });
}else {
    CallbackError();
}

function CallbackSuccess(){
    Axios({
        url     : process.env.REACT_APP_API_URL + 'php/inc/list_data.php',
        mode    : 'no-cors',
        method  : 'POST',
        data    : data
    })
    .then(response => {
        console.log(response.data);
        SetListData(response.data);

        root.render(
            <React.Fragment>
                <App loadingDataPage={ CallbackSuccess } />
            </React.Fragment>
        );
    });
}

function CallbackError(){ 
    root.render(
        <React.Fragment>
            <App loadingDataPage={ CallbackSuccess } />
        </React.Fragment>
    );
}